import React from 'react'
import tw, { css, styled } from 'twin.macro'

import { Link } from 'gatsby'
import { ChevronLeft, ChevronRight } from 'react-feather'
import { BLOCKS, MARKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Img from 'gatsby-image'
import SLine from '../svg/s-line'
import MLine from '../svg/m-line'
import XLine from '../svg/x-line'
import Eline from '../svg/e-line'
import useSlider from '../../hooks/useSlider'

import {
	Section,
	Title,
	Subtitle,
	Innertext,
	Item,
	Content,
	ItemSubTitle,
	Paragraph,
	Italic,
	UnorderedList,
	ItemButton,
	ItemImage,
	FeaturedButtonHolder,
	FeaturedContainer,
	FeaturedHolder,
	Previous,
	Next,
	ViewMore,
	ViewMoreBtn,
	Bold,
} from './styles'

const Mline = styled(MLine)`
	${tw`mb-3`}
`
const Sline = styled(SLine)`
	${tw`mb-3`}
`
const Xline = styled(XLine)`
	${tw`mb-3`}
`
const ELine = styled(Eline)`
	${tw`mb-3`}
`
const DolphinLines = ({ locale, dolphinlines, checkedLocale }) => {
	const getCountry = locale.split('-')[1].toLowerCase()
	const { title, subtitle, items } = dolphinlines
	const options = {
		renderMark: {
			[MARKS.BOLD]: text => <Bold>{text}</Bold>,
			[MARKS.ITALIC]: text => <Italic>{text}</Italic>,
		},
		renderNode: {
			[BLOCKS.EMBEDDED_ASSET]: node => {
				const { file, description } = node.data.target.fields
				return <ItemImage src={file['en-AU'].url} alt={description['en-AU']} />
			},
			[BLOCKS.PARAGRAPH]: (node, children) => <Paragraph>{children}</Paragraph>,
			[BLOCKS.HEADING_4]: (node, children) => (
				<ItemSubTitle>{children}</ItemSubTitle>
			),
			[BLOCKS.UL_LIST]: (node, children) => (
				<UnorderedList>{children}</UnorderedList>
			),
		},
	}

	const {
		containerWidth,
		imgLen,
		gram,
		arr,
		transition,
		transitionValue,
		PreviousGramHandler,
		NextGramHandler,
		arrLen,
	} = useSlider(items)
	return (
		<Section>
			<Title>{title}</Title>
			<Subtitle>{subtitle}</Subtitle>
			<Innertext>No matter the size, shape or type of pool, nothing cleans like a Maytronics Dolphin. Our range of smart robotic pool cleaners suck up dirt and debris and scrub the floor and walls leaving you with crystal clear water. Your Dolphin automatic pool cleaner allows you to spend more time enjoying your pool and less time cleaning it.
			</Innertext>
			<FeaturedButtonHolder arrLen={arrLen}>
				<FeaturedContainer>
					<FeaturedHolder
						ref={containerWidth}
						css={{
							transform: `translate3d(${transitionValue}px, 0, 0)`,
							transition: transition ? 'all 0.5s linear' : '',
						}}
					>
						{gram.map((item, index) => {
							return (
								<Item
									key={index}
									ref={imgLen}
									arrLen={arrLen}
								>
									<Link to={`${checkedLocale}/${item.url}`}>
										<Img
											fluid={item.image.fluid}
											alt={item.image.description}
											className="item-image"
										/>
									</Link>
									<Content>
										{item.name === 'M Line' ? (
											<Mline width="100" height="40" />
										) : item.name === 'S Line' ? (
											<Sline width="100" height="40" />
										) : item.name === 'X Line' ? (
											<Xline width="100" height="40" />
										) : item.name === 'E Line' ? (
											<ELine width="100" height="40" />
										) : (
											''
										)}
										{item.body
											? documentToReactComponents(item.body.json, options)
											: ''}
										<Link to={`${checkedLocale}/${item.url}`}>
											<ItemButton>Learn More</ItemButton>
										</Link>
									</Content>
								</Item>
							)
						})}
					</FeaturedHolder>
				</FeaturedContainer>
				<Previous disabled={transition} onClick={() => PreviousGramHandler()}>
					<ChevronLeft color="#58C8DF" width="70" height="70" />
				</Previous>
				<Next disabled={transition} onClick={() => NextGramHandler()}>
					<ChevronRight color="#58C8DF" width="70" height="70" />
				</Next>
				<ViewMore>
					{
						locale === 'en-AU' ? (
							<ViewMoreBtn to={`${checkedLocale}/shop/?brand=Dolphin`}>
								View All Models
							</ViewMoreBtn>
						) : (
							<ViewMoreBtn to={`https://mydolphin.co.${getCountry}/pool-cleaners/`}>
								View All Models
							</ViewMoreBtn>
						)
					}
				</ViewMore>
			</FeaturedButtonHolder>
		</Section>
	)
}

export default DolphinLines
